// src/components/Header.jsx
import React, { useState } from 'react';
import './Header.css';
import emblem1 from '../kg.png';
import emblem2 from '../minselhoz-logo.svg';
import { useTranslation } from 'react-i18next';

function Header() {
    const { t, i18n } = useTranslation();
    const [menuOpen, setMenuOpen] = useState(false);

    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
    };

    const closeMenu = () => setMenuOpen(false);

    return (
        <header className="header">
            <div className="header-container">
                {/* ЛЕВО — логотипы */}
                <div className="header-left">
                    <img src={emblem1} alt="Герб 1" className="emblem" />
                    <img src={emblem2} alt="Герб 2" className="emblem" />
                    <div className="logo">AFACI</div>
                </div>

                {/* ЦЕНТР — навигация (скрыта на мобилке) */}
                <ul className="nav-links">
                    <li><a href="/">{t('header.nav1')}</a></li>
                    <li><a href="/products">{t('header.nav2')}</a></li>
                    <li><a href="/national">{t('header.nav3')}</a></li>
                    <li><a href="/about">{t('header.nav4')}</a></li>
                    <li><a href="/booklets">{t('header.nav5')}</a></li>
                </ul>

                {/* ПРАВО — язык, войти, бургер */}
                <div className="header-right">
                    <div className="lang-switcher">
                        <button className="lang-toggle">🌐</button>
                        <div className="lang-dropdown">
                            <button onClick={() => changeLanguage('ru')}>🇷🇺 Русский</button>
                            <button onClick={() => changeLanguage('en')}>🇬🇧 English</button>
                        </div>
                    </div>
                    <a href="/auth" className="login">{t('auth.nav1')}</a>

                    {/* Кнопка-бургер: только на мобилке */}
                    <button
                        className={`burger-btn ${menuOpen ? 'burger-btn--open' : ''}`}
                        onClick={() => setMenuOpen(!menuOpen)}
                        aria-label="Открыть меню"
                    >
                        <span />
                        <span />
                        <span />
                    </button>
                </div>
            </div>

            {/* Мобильное меню */}
            <nav className={`mobile-nav ${menuOpen ? 'mobile-nav--open' : ''}`}>
                <ul>
                    <li><a href="/" onClick={closeMenu}>{t('header.nav1')}</a></li>
                    <li><a href="/products" onClick={closeMenu}>{t('header.nav2')}</a></li>
                    <li><a href="/national" onClick={closeMenu}>{t('header.nav3')}</a></li>
                    <li><a href="/about" onClick={closeMenu}>{t('header.nav4')}</a></li>
                    <li><a href="/booklets" onClick={closeMenu}>{t('header.nav5')}</a></li>
                    <li><a href="/auth" onClick={closeMenu}>{t('auth.nav1')}</a></li>
                </ul>
                <div className="mobile-lang">
                    <button onClick={() => { changeLanguage('ru'); closeMenu(); }}>🇷🇺 Русский</button>
                    <button onClick={() => { changeLanguage('en'); closeMenu(); }}>🇬🇧 English</button>
                </div>
            </nav>
        </header>
    );
}

export default Header;
